<template lang="pug" src="./driver-news.pug"></template>
<style lang="scss" src="./driver-news.scss" scoped></style>

<script>
import scroll from '@/utils/scroll';

import { mapState } from 'vuex';

export default {
    data: () => ({
        filters: {
            fromDate: null,
            toDate: null,
            shown: null,
            phone: null,
            scope: null
        },
        dateStartInput: false,
        dateEndInput: false,
        tableState: {},
        deletingArticle: null,
        deleteDialogOpen: false
    }),
    computed: {
        ...mapState({
            articles: state => state.driverNewsView.articles,
            isTableLoad: state => state.driverNewsView.isLoaded,
            pagination: state => state.driverNewsView.pagination,
            appliedFilters: state => state.driverNewsView.filters
        }),
        headers() {
            return [
                { text: 'id', value: 'id' },
                { text: 'header', value: 'header', sortable: false },
                { text: 'text', value: 'text', sortable: false },
                { text: 'sendTo', value: 'sendTo', sortable: false },
                { text: 'status', value: 'status' },
                { text: 'createdAt', value: 'createdAt' },
                { text: 'actions', value: 'actions', sortable: false }
            ].map(it => Object.assign(it, {
                text: this.$vuetify.lang.t(`$vuetify.pages.DriverNews.table.${it.text}`)
            }));
        }
    },
    watch: {
        sorting: {
            handler() {
                this.getArticlesByPage();
            },
            deep: true
        },
        tableState: {
          handler () {
            this.getArticlesByPage();
          },
          deep: true,
        },
    },
    created: function() {
        this.filters = Object.assign({}, this.appliedFilters);
    },
    beforeRouteLeave: function(to, from, next) {
        this.$store.commit('driverNewsView/SET_PAGINATION', { page: 1, length: null });
        next();
    },
    methods: {
        openDeleteModal(id) {
            this.deletingArticle = id;
            this.deleteDialogOpen = true;
        },
        closeDeleteModal() {
            this.deletingArticle = null;
            this.deleteDialogOpen = false;
        },
        async deleteArticle() {
            await this.$store.dispatch('driverNewsView/dropArticle', this.deletingArticle);

            this.closeDeleteModal();
            this.getArticlesByPage();
        },
        submit() {
            this.$store.commit('driverNewsView/SET_FILTERS', Object.assign({}, this.filters));

            this.getArticlesByPage();
        },
        reset() {
            this.filters = Object.assign({}, {
                fromDate: null,
                toDate: null
            });
            this.$store.commit('driverNewsView/RESET_ARTICLE_FILTERS');
            this.getArticlesByPage();
        },
        getArticlesByPage(page, isScrollEnable = false, excel = false) {
            if (!page) {
                page = this.tableState.page;
            }

            this.$store.dispatch('driverNewsView/getArticles', {
                excel,
                page,
                column: this.tableState.sortBy[0],
                direction: this.tableState.sortDesc[0] ? 'desc' : 'asc',
                ...this.appliedFilters
            }).then(() => {
                if (isScrollEnable) {
                    scroll(this.$refs.table);
                }
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.getArticlesByPage(page, true);
            }
        },
        addArticle() {
            this.$router.push('/add-driver-article');
        },
        openEditor(id) {
            this.$router.push(`driver-news/editor/${id}`);
        },
        exportToExcel() {
            this.getArticlesByPage(1, false, true);
        }
    }
};
</script>
